import styled from 'styled-components';

export {
  Name,
  Reward as Coupon,
  RewardAndButtonWrapper as CouponAndButtonWrapper,
} from '../rewards/item.styles';

export const Badge = styled.div<{ isLong: boolean }>`
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--text);
  border-radius: var(--border-radius-round);
  color: var(--background);
  text-align: center;
  font-family: Butler, serif;
  font-size: ${(props) => (props.isLong ? '12px' : '20px')};
`;

export const Description = styled.p`
  flex-grow: 1;
  margin: 0;
  white-space: pre-wrap;
`;

export const Status = styled.p<{ available: boolean; activated: boolean }>`
  margin: 0 0 16px;
  color: ${(props) =>
    props.available
      ? props.activated
        ? 'var(--success-dark)'
        : 'var(--primary)'
      : 'var(--text-light)'};

  svg {
    position: relative;
    top: 3px;
  }
`;

export const DetailsItem = styled.div`
  margin-top: 16px;
`;

export const DetailsItemContent = styled.p`
  display: inline;
`;

export const ButtonAndRoadblockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
